import React from 'react';
import MainPage from './MainPage';
import Chatbot from './Chatbot';
import './App.css';

function App() {
  return (
    <div className="App">
      <MainPage />
      <Chatbot />
    </div>
  );
}

export default App;
